import React from 'react';

import './Experience.css';

function Experience({ ...props }) {
  return (
    <div>
      <div className="experience-container">
        <p className="date">2025 - Current</p>
        <div className="description">
          <h2>
            Freelance Web Developer @{' '}
            <a href="https://www.onswitchboard.com/" className="hover">
              Williamson Mechanical and Contracting
            </a>
          </h2>
          <p>Vancouver, BC, CA</p>
        </div>
      </div>
      <div className="experience-container">
        <p className="date">2022 - 2024</p>
        <div className="description">
          <h2>
            Full-Stack Developer @{' '}
            <a href="https://www.onswitchboard.com/" className="hover">
              Switchboard ↗
            </a>
          </h2>
          <p>Burnaby, BC, CA</p>
        </div>
      </div>
    </div>
  );
}

export default Experience;
